import {VideoCameraOutlined} from '@ant-design/icons'
import Commonview from '../../../pages/common_view';
import VideoList from "../../../pages/video_manage/video_list";

const videoRouter = [
    {
        path: '/videoManage',
        element: <Commonview/>,
        meta: {title: '视频管理', icon: <VideoCameraOutlined />},
        children: [
            {
                path: '/videoManage/videoList',
                meta: {title: '视频列表', key: 'video_management'},
                element: <VideoList/>,
            }
        ]
    }
]

export default videoRouter
